"use client";

import { Pills } from "@/components/common/pills/Pills";
import { ContestListProps } from ".";
import { i18nKey } from "@/lib/react/i18n/types/locale";

const StatusPills = ({
  selected,
  onChange,
  t,
}: {
  selected: ContestListProps["selectedStatuses"];
  onChange: ContestListProps["onChangeStatuses"];
  t: (key: i18nKey) => string;
}) => {
  const items: Array<{ key: ContestListProps["selectedStatuses"][number]; label: string }> = [
    { key: "OPEN", label: t("Preparations underway") },
    { key: "SUBMISSION", label: t("Submission Period") },
    { key: "SCORING", label: t("Scoring Period") },
    { key: "FINISHED", label: t("Contest closed") },
  ];

  return (
    <Pills
      mode="multi"
      items={items}
      selected={selected}
      onChange={onChange}
      allLabel={t("All")}
      showAllButton
    />
  );
};

export default StatusPills;